import { DefTypes } from '../../constants';
import Ajax from '../../utils/ajax';
import ErrorParser from '../../utils/errorParser';
import {
  currentUserAgent,
  deepMerge,
  getDeviceToken, getInput,
  getLocation,
  getReportUserId,
  getServiceWithStage,
  getType,
} from '../../utils/func';
import SystemOptions from '../../utils/options';
import { processErrorData, processErrorDataV2 } from '../collector';

export async function sendEventV2(
  params: {
    eventType: any,
    data: any,
    labels?: {
      [key: string]: string,
    },
    level?: string,
  },
  options: any,
  onSuccess?: (res: any) => void,
  onError?: (error: any) => void,
) {
  const userOpts = SystemOptions.getInstance().getOptions();
  const opts: any = deepMerge(userOpts, options);
  const payload = getType(params.data) === DefTypes.OBJECT ? JSON.stringify(params.data) : params.data;
  const eventData = {
    eventType: params.eventType,
    payload,
    labels: params.labels,
    level: params.level,
    ua: currentUserAgent,
    refer: window.document.referrer || '',
    url: getLocation(),
    serviceWithStage: getServiceWithStage(),
    browserId: getDeviceToken(opts.deviceTokenKey),
    visitId: SystemOptions.getInstance().getVisitId(),
    // TODO 当获取不到 userId 时（以游客身份访问系统），用生成的 browserId 填充
    userId: getReportUserId(opts),
    feBu: getInput('feBu'),
    feVersion: getInput('feVersion'),
  };

  try {
    const res = await Ajax.send(eventData, opts.newEventApiUrl);
    if (onSuccess && getType(onSuccess) === DefTypes.FUNC) {
      onSuccess(res);
    }
  } catch (error) {
    if (onError && getType(onError) === DefTypes.FUNC) {
      onError(error);
    }
  }
}

export async function sendEvent(
  eventType: any,
  data: any,
  options: any,
  onSuccess?: (res: any) => void,
  onError?: (error: any) => void,
) {
  const userOpts = SystemOptions.getInstance().getOptions();
  const opts = deepMerge(userOpts, options || { });
  const eventData = {
    eventType,
    payload: data,
    ua: currentUserAgent,
    refer: window.document.referrer || '',
    url: getLocation(),
    serviceWithStage: getServiceWithStage(),
    browserId: getDeviceToken(opts.deviceTokenKey),
    visitId: SystemOptions.getInstance().getVisitId(),
    // TODO 当获取不到 userId 时（以游客身份访问系统），用生成的 browserId 填充
    userId: getReportUserId(opts),
  };

  try {
    const res = await Ajax.send(eventData, opts.eventApiUrl);
    if (onSuccess && getType(onSuccess) === DefTypes.FUNC) {
      onSuccess(res);
    }
  } catch (error) {
    if (onError && getType(onError) === DefTypes.FUNC) {
      onError(error);
    }
  }
}

export async function sendError(error: any, options: any) {
  const userOpts = SystemOptions.getInstance().getOptions();
  const opts = deepMerge(userOpts, options);
  if (error) {
    // V1 版本不兼容 labels 定义，放弃维护
    const { parsedStack } = ErrorParser.parseStack(error, opts.maxStackDepth);
    await processErrorData(parsedStack, opts);
  }
}

export async function sendErrorV2(
  params: {
    error: any,
    labels?: {
      [key: string]: string,
    },
    level?: string,
  },
  options: any,
) {
  const userOpts = SystemOptions.getInstance().getOptions();
  const opts = deepMerge(userOpts, options);
  if (params.error) {
    const { parsedStack, labels } = ErrorParser.parseStack(params.error, opts.maxStackDepth);
    if (params.labels) {
      params.labels = deepMerge(params.labels, labels);
    }
    await processErrorDataV2(parsedStack, opts, params.labels || { }, params.level);
  }
}
